import React from 'react'
import SwitchSvg from '../../../Assets/Images/icons/SwitchSvg'

const STEPS = {
  STEP_1: 'STEP_1',
  STEP_2: 'STEP_2',
  SUCCESS: 'SUCCESS',
}

const NEXT_STEPS = [
  {
    img: <SwitchSvg />,
    name: 'Verify your account',
    description: 'Click on the link in the email to verify your account.',
  },
  {
    img: <SwitchSvg style={{ transform: 'rotate(180deg)' }} />,
    name: 'Start using Promofy',
    description:
      'Log in to Promofy and start exploring features, and create your campaigns',
  },
]

const getInitialSignupData = (isEDDMUser, query) => {
  return {
    firstName: { value: '', error: true },
    lastName: { value: '', error: true },
    email: {
      value: query.get('email') || '',
      error: true,
      additionalError: false,
    },
    phone: { value: '', error: true },
    password: { value: '', error: true },
    companyName: { value: '', error: true, additionalError: false },
    countryId: {
      value: isEDDMUser ? '14' : '',
      error: isEDDMUser ? false : true,
    },
    industry: { value: '', error: true },
    industryGroup: { value: '', error: true },
    providerType: { value: '', error: true },
    providerUserId: { value: '', error: true },
  }
}

export { STEPS, NEXT_STEPS, getInitialSignupData }
